"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LangSwitcher = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const translations_1 = require("@front/application/globals/translations");
const trans_1 = require("../../../../common/translations/trans");
//@ts-ignore                
let rwsTemplate = T.html `<div class="ml-2 dropdown${x => x.langsOpened ? ' show' : ''}">
    <button @click="${(x, c) => x.toggleLangs()}" type="button" class="language-button dropdown-toggle btn btn-light btn-sm" id="languageDropdown"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="name lang-name"><img src="${(x, c) => x.getFlagUrl(x.chosenLang)}" class="lang-flag chosen"/>${x => x.chosenLang}</span>
    </button>
    <div id="lang-list" class="dropdown-menu dropdown-menu-right${x => x.langsOpened ? ' show' : ''}" aria-labelledby="languageDropdown">
        ${(0, fast_element_1.repeat)(x => x.languages, (0, fast_element_1.html) `
            <button @click="${(x, c) => c.parent.setLang(x)}" class="dropdown-item" type="button"><img src="${(x, c) => c.parent.getFlagUrl(x)}" class="lang-flag"/>${x => x}</button>
        `)}
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.lang-name, #lang-list button {
  text-transform: uppercase;
}

.lang-flag {
  width: 30px;
  height: 20px;
  margin-right: 10px;
  border: 1px solid #000;
}
.lang-flag.chosen {
  border: none;
}`;
const shadowOptions = { "mode": "open" };
let LangSwitcher = class LangSwitcher extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.langsOpened = false;
        this.languages = (0, trans_1.getLanguageList)();
    }
    connectedCallback() {
        super.connectedCallback();
        this.chosenLang = (0, translations_1.getLanguage)();
    }
    getFlagUrl(lang) {
        switch (lang) {
            case 'en':
                lang = 'gb';
                break;
            case 'zh':
                lang = 'cn';
                break;
        }
        return `https://flagpedia.net/data/flags/h80/${lang}.webp`;
    }
    toggleLangs() {
        this.langsOpened = !this.langsOpened;
    }
    setLang(lang) {
        (0, translations_1.setLanguage)(lang);
        window.location.reload();
    }
};
exports.LangSwitcher = LangSwitcher;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], LangSwitcher.prototype, "langsOpened", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], LangSwitcher.prototype, "chosenLang", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], LangSwitcher.prototype, "languages", void 0);
exports.LangSwitcher = LangSwitcher = __decorate([
    (0, client_1.RWSView)('lang-switcher', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], LangSwitcher);
LangSwitcher.defineComponent();
